import { useEffect, useState } from 'react';
import axios from 'axios';
import { Eye } from 'lucide-react';
import { API_BASE as API } from '../../config';

/**
 * One-line email-engagement summary shown inside the user-menu dropdown
 * (right under the user's name/email). Scoped to "Mine" so users see *their
 * own* engagement at a glance — they can click "Email Engagement" lower in
 * the menu for an org-wide view.
 *
 * Renders nothing when the user hasn't sent any emails in the last 30 days
 * to avoid noise in the dropdown for tenants that don't use email.
 */
export const InlineEngagementSummary = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/email/engagement-stats?days=30&scope=mine`)
      .then((r) => { if (alive) setStats(r.data); })
      .catch(() => { if (alive) setStats(null); });
    return () => { alive = false; };
  }, []);

  if (!stats || stats.total_sent === 0) return null;
  return (
    <div
      className="flex items-center gap-1.5 mt-1 text-[11px] text-gray-500"
      data-testid="user-menu-engagement-summary"
      title={`Sent ${stats.total_sent}, opened ${stats.opened} (${stats.open_rate}% open rate)`}
    >
      <Eye className="w-3 h-3 text-emerald-500" />
      <span>
        {stats.total_sent} sent · {stats.opened} opened ({stats.open_rate}%)
      </span>
    </div>
  );
};

export default InlineEngagementSummary;
